import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class AccountRoute extends Route {
  @service('current-user') currentUser;

  model() {
    return this.currentUser.currentUser;
  }
}

export default instrumentRoutePerformance(AccountRoute);
